import sptk from '../../libs/sptk.js';

import getPosition from '../helpers/position';
import { getOuterHeight, getInnerWidth } from '../helpers/dimensions';

export default class Sticky {
    constructor(opts) {
        this.options = opts;
        this.$el = opts.el;

        this.isSticky = false;
        this.isStickyBottom = false;

        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.storeSizes();

        if (this.options.contained) {
            this.setContainedProps();
        }

        if (this.options.anchors) {
            this.setAnchors();
            this.bindAnchorsEvents();
        }

        this.setFadeTriggers();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};
    }

    bindEvents() {
    }

    bindAnchorsEvents() {
        [].forEach.call(this.ui.$anchors, (anchor) => {
            anchor.addEventListener('click', this.onClickAnchor.bind(this));
        });
    }

    onClickAnchor(e) {
        e.preventDefault();

        const currentTarget = e.currentTarget,
            targetHref = currentTarget.getAttribute('href');

        const foundIndex = this.anchors.findIndex(anchor => {
            return targetHref === anchor.id;
        });

        sptk.utils.goTo(this.anchors[foundIndex].offsetTop + 1, 750);
    }

    update(scrollTop = 0) {
        this.unstick();
        this.unstickBottom();

        this.storeSizes();

        if (this.options.anchors) {
            this.setAnchors();
        }

        this.setFadeTriggers();

        setTimeout(() => {
            if (this.options.contained) {
                this.setContainedProps();
            }

            if (this.options.anchors) {
                this.checkAnchors(scrollTop);
            }

            this.checkFadeTriggers(scrollTop);
            this.checkScroll(scrollTop);
        }, 200);
    }

    updateOffsetBottom(scrollTop) {
        this.sizes.height = this.$el.clientHeight;

        if (this.options.contained) {
            this.sizes.offsetBottom = (this.sizes.offsetTop + getOuterHeight(this.ui.$parent)) - this.sizes.height;
        } else {
            this.sizes.offsetBottom = document.body.clientHeight;
        }

        setTimeout(() => {
            if (this.options.anchors) {
                this.checkAnchors(scrollTop);
            }

            this.checkFadeTriggers(scrollTop);
            this.checkScroll(scrollTop);
        }, 200);
    }

    setContainedProps() {
        // Resetting width
        this.$el.style.width = 'auto';

        // Set specific UI
        this.ui.$parent = this.$el.closest(this.options.parent);

        // Set specific Sizes
        this.sizes.offsetBottom = (this.sizes.offsetTop + getOuterHeight(this.ui.$parent)) - this.sizes.height;
        this.sizes.width = getInnerWidth(this.ui.$parent);

        // Set specific width
        this.$el.style.width = `${this.sizes.width}px`;
    }

    storeSizes() {
        this.sizes = {
            offsetTop: getPosition(this.$el).top + (this.options.offsetTop || 0),
            offsetBottom: document.body.clientHeight,
            width: this.$el.clientWidth,
            height: this.$el.clientHeight
        };
    }

    setAnchors() {
        // Setting the anchors
        this.ui.$anchors = this.$el.querySelectorAll(this.options.anchors);

        // Setting an empty array to store them all
        this.anchors = [];

        // Looping around the items to find the candidates
        [].forEach.call(this.ui.$anchors, (anchor) => {
            const anchorHref = anchor.getAttribute('href'),
                $targetAnchor = document.querySelector(anchorHref);

            // If found setting the correct offsets and stuff
            if ($targetAnchor) {
                // Setting the object
                this.anchors.push({
                    id: anchorHref,
                    $el: anchor,
                    offsetTop: getPosition($targetAnchor).top + (this.options.offsetTop || 0),
                    isActive: false
                });
            }
        });
    }

    setFadeTriggers() {
        this.ui.$fadeTriggers = document.querySelectorAll('.js-sticky-fade');

        this.fadeTriggers = [];

        [].forEach.call(this.ui.$fadeTriggers, (trigger) => {
            const $currentTrigger = trigger;
            const threshold = 100;

            this.fadeTriggers.push({
                isActive: false,
                offsetTop: getPosition($currentTrigger).top - (this.sizes.height + (this.options.offsetTop || 0) + (threshold * 2)),
                offsetBottom: getPosition($currentTrigger).top + (this.options.offsetTop || 0) + $currentTrigger.clientHeight + (threshold * 2)
            });
        });
    }

    unstick() {
        this.isSticky = false;

        this.$el.classList.remove('is-sticky');
    }

    stick() {
        this.isSticky = true;

        this.$el.classList.add('is-sticky');
    }

    unstickBottom() {
        this.isStickyBottom = false;

        this.$el.classList.remove('is-sticky-bottom');
    }

    stickBottom() {
        this.isStickyBottom = true;

        this.$el.classList.add('is-sticky-bottom');
    }

    setFaded() {
        this.$el.classList.add('is-faded');
    }

    unsetFaded() {
        this.$el.classList.remove('is-faded');
    }

    setPadded() {
        this.$el.classList.add('is-padded');
    }

    unsetPadded() {
        this.$el.classList.remove('is-padded');
    }

    activeAnchor(anchor) {
        anchor.isActive = true;

        anchor.$el.classList.add('is-active');
    }

    unactiveAnchor(anchor) {
        anchor.isActive = false;

        anchor.$el.classList.remove('is-active');
    }

    activeTrigger(trigger) {
        trigger.isActive = true;

        this.setFaded();
    }

    unactiveTrigger(trigger) {
        trigger.isActive = false;

        this.unsetFaded();
    }

    checkAnchors(scrollTop) {
        for (let i = 0, j = this.anchors.length; i < j; i++) {
            const currentAnchor = this.anchors[i];

            if (scrollTop > currentAnchor.offsetTop) {
                if (!currentAnchor.isActive) {
                    this.activeAnchor(currentAnchor);
                }
            } else {
                if (currentAnchor.isActive) {
                    this.unactiveAnchor(currentAnchor);
                }
            }
        }
    }

    checkFadeTriggers(scrollTop) {
        for (let i = 0, j = this.fadeTriggers.length; i < j; i++) {
            const currentTrigger = this.fadeTriggers[i];

            if (scrollTop > currentTrigger.offsetTop) {
                if (scrollTop < currentTrigger.offsetBottom) {
                    if (!currentTrigger.isActive) {
                        this.activeTrigger(currentTrigger);
                    }
                } else {
                    if (currentTrigger.isActive) {
                        this.unactiveTrigger(currentTrigger);
                    }
                }
            } else {
                if (currentTrigger.isActive) {
                    this.unactiveTrigger(currentTrigger);
                }
            }
        }
    }

    checkScroll(scrollTop) {
        this.checkFadeTriggers(scrollTop);

        if (scrollTop > this.sizes.offsetTop) {
            if (scrollTop < this.sizes.offsetBottom) {
                if (!this.isSticky) {
                    this.stick();
                }

                if (this.isStickyBottom) {
                    this.unstickBottom();
                }
            } else {
                if (this.isSticky) {
                    this.unstick();
                }

                if (!this.isStickyBottom) {
                    this.stickBottom();
                }
            }
        } else {
            if (this.isSticky) {
                this.unstick();
            }

            if (this.isStickyBottom) {
                this.unstickBottom();
            }

        }
    }
}
